import React from 'react'
import { CiFaceSmile } from "react-icons/ci";
import { CiUser } from "react-icons/ci";
import { DivTag, HeadTag, PTag, ImgTag } from '../Tags/Tags';

const TestimonialCard = () => {
    return (

        <DivTag className="bg-blue-900 text-white p-1 mt-1 md:mt-2 md:w-1/3 rounded-lg md:h-1/2 ">
            <DivTag className="flex items-center justify-between">
                <DivTag className=" font-bold size-25 ">
                    <img src="/media/logo/idspay_horizontal_white.png" alt="logo" /></DivTag>
            </DivTag>
            <HeadTag className=" font-bold mt-1 flex items-center justify-between text-center underline" text="Best Solution For Indian START-UP’s" />
       
    <PTag
  className="mt-2"
  text={
    <>
      <span className="font-bold">IDSPay offer’s more than 150+ API Products for the Indian company.</span> 
      <hr className="border border-white" />
     IDSPay expertise in Core Banking Software, E-Commerce Software,
      CRM Software, Loan Collection Software, Micro-Finance & NBFC Software, Path Lab Software, Nidhi Company Software,
      NGO Software, School Management Software, Institute Management Software, Hostel Management Software, etc.
    </>
  }
/>

            <DivTag className="flex items-center mt-4 bg-white rounded-md">
                <CiFaceSmile color='blue' />
                <PTag className="text-lg text-black border-lg rounded" text="24000+ Happy Customers" />
            </DivTag>
        </DivTag>
    );
};

export default TestimonialCard
